import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
function useRoom(id) {
    const spa = Common.useSpaContext();
    const roomInfo = getStateValueByPath(spa?.state, id) ??
        (spa?.state && id in spa.state ? spa.state[id] : undefined);
    if (roomInfo && typeof roomInfo === 'object') {
        return roomInfo;
    }
    return {};
}
function isObject(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}
function getStateValueByPath(state, path) {
    if (!state || !path) {
        return undefined;
    }
    return path.split('.').reduce((current, key) => {
        if (!isObject(current)) {
            return undefined;
        }
        return current[key];
    }, state);
}
function formatTemperature(temp) {
    return formatNumber(temp) + '°C';
}
function formatNumber(value) {
    if (value === undefined) {
        return 'N/A';
    }
    if (typeof value === 'string') {
        value = Number.parseFloat(value);
    }
    return Intl.NumberFormat().format(value);
}
function toNumber(value) {
    if (value === undefined) {
        return undefined;
    }
    return typeof value === 'number' ? value : Number.parseFloat(value);
}
export function RenderRoomButtonWidget(component) {
    return _jsx(RoomButtonWidget, { id: component.properties.id });
}
export function RenderRoomFrameWidget(component) {
    return _jsx(RoomFrameWidget, { id: component.properties.id });
}
export function RenderRoomScreenWidget(component) {
    return _jsx(RoomScreenWidget, { id: component.properties.id });
}
export function RoomButtonWidget(props) {
    const room = useRoom(props.id);
    function getDetails() {
        const details = [];
        if (room?.temp) {
            details.push(_jsx("div", { children: formatTemperature(room?.temp) }, "1"));
        }
        if ((toNumber(room?.co2) || 0) >= 800) {
            details.push(_jsxs("div", { children: ["CO2: ", formatNumber(room.co2), " ppm"] }, "2"));
        }
        if ((toNumber(room?.humidity) || 0) >= 80) {
            details.push(_jsxs("div", { children: ["Humidity: ", formatNumber(room.humidity), "%"] }, "3"));
        }
        return details;
    }
    const details = getDetails();
    function getTileSize() {
        if (details.length === 0) {
            return Components.TileSize.SmallLong;
        }
        return details.length > 1 ? Components.TileSize.Long : Components.TileSize.LongThin;
    }
    return (_jsx(Common.WidgetButton, { tileSize: getTileSize(), children: _jsxs("div", { children: [_jsx("h1", { children: _jsx(Common.MLT, { id: props.id }) }), details] }) }));
}
export function RoomFrameWidget(props) {
    const room = useRoom(props.id);
    const devices = {};
    for (const key in room) {
        const item = room[key];
        if (isObject(item) && item.type) {
            devices[key] = item;
        }
    }
    return (_jsxs(Common.WidgetFrame, { children: [room?.temp && _jsx("h1", { children: formatTemperature(room?.temp) }), _jsx(Components.Property, { title: _jsx(Common.MLT, { id: "co2" }), children: formatNumber(room?.co2) + ' ppm' }), _jsx(Components.Property, { title: _jsx(Common.MLT, { id: "humidity" }), children: formatNumber(room?.humidity) + '%' })] }));
}
export function RoomScreenWidget(props) {
    const room = useRoom(props.id);
    const widgetContext = Common.useWidgetContext();
    const placementManager = widgetContext.placementManager;
    const devices = {};
    for (const key in room) {
        const item = room[key];
        if (isObject(item) && item.type) {
            devices[key] = item;
        }
    }
    function formatDeviceValue(child, index) {
        const placement = {
            type: Common.WidgetPlaceholderType.Tiles,
            size: Common.WidgetSize.Button,
        };
        return [child, placement];
    }
    const widgets = widgetContext.config.children?.map((child, index) => formatDeviceValue(child, index)) || [];
    return (_jsxs(Common.WidgetFrame, { children: [_jsx(Components.Property, { title: _jsx(Common.MLT, { id: "temperature" }), children: formatTemperature(room?.temp) }), _jsx(Components.Property, { title: _jsx(Common.MLT, { id: "co2" }), children: formatNumber(room?.co2) + ' ppm' }), _jsx(Components.Property, { title: _jsx(Common.MLT, { id: "humidity" }), children: formatNumber(room?.humidity) + '%' }), _jsx(Common.WidgetPlaceholder, { type: Common.WidgetPlaceholderType.Tiles, name: props.id })] }));
}
